module.exports = __webpack_public_path__ + "img/CIMG0030.d02902e8.jpg";